
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.03 9.992l-4.042-4.048 2.922-2.927 4.041 4.046-2.92 2.93zM7.62 20.432l-4.465.407.396-4.44 8.426-8.437 4.045 4.05-8.401 8.42zM23.109 4.98l-.001-.001L18.999.866c-1.111-1.11-3.021-1.162-4.074-.103L1.429 14.275A2.966 2.966 0 00.574 16.1l-.568 6.264a1.5 1.5 0 001.63 1.631l6.256-.57a2.96 2.96 0 001.821-.852L23.21 9.056c1.092-1.096 1.046-2.926-.102-4.077z","fill":"currentColor"}})])
          )
        }
      }
    